import ApiClient, {requestRemoteData} from '../../API/api';

const GET_ADDRESSES_ENDPOINT = 'account/address';
const SET_DEFAULT_DELIVERY_ADDRESS_ENDPOINT = 'account/address/:addressId/delivery'
const GET_DELIVERY_ADDRESSES_ENDPOINT = 'account/address/delivery';

/**
 *
 * @returns {Promise<Array<Address>>}
 */
export const fetchAddresses = () => {
  return ApiClient.performRequest(GET_ADDRESSES_ENDPOINT);
}

/**
 * @param addressId
 * @returns {Promise<*>}
 */
export const setDefaultDeliveryAddress = (addressId) => {
  return ApiClient.performRequest(SET_DEFAULT_DELIVERY_ADDRESS_ENDPOINT, {
    method: 'PUT',
    pathParams: { addressId }
  });
};

/**
 * @returns {Promise<RemoteData<Address>>}
 */
export const getDeliveryAddresses = (actingAsNumCliente = null) => {
  const headers = actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};
  return requestRemoteData(GET_DELIVERY_ADDRESSES_ENDPOINT, { headers });
};
